import { Tooltip, Modal, Slider } from "antd";
import React, { useState } from "react";
import styles from "./chatBottomAttachments.module.scss";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import iconNotSupported from "../../../../styles/images/hiddenimage.svg";
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useSelector } from "react-redux";
import { chatSocketReducerStateModel, filesArray, initialStateModel } from "../../../../models/model";
import store from "../../../../context/store/store";
import { actionTypes } from "../../../../context/action/action";
import { getFileSize, wordMimeFormats, excelMimeFormats, pptMimeFormats, zipMimeFormats, pptFormats }
  from "../../../../base/utils";
import { DraftService } from "../../../../base/draftService";
  type multiChatProps = {
    nameValue?: any;
  };
export default function ChatBottomAttachments({ nameValue}: multiChatProps) {
 
  // const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const { filesAttach }: chatSocketReducerStateModel = useSelector((state: initialStateModel) => state.chatSocketReducerState);
  const [openPreviewFile, setopenPreviewFile] = useState<filesArray>({
    txt: "sample",
    messageType: "FILE", mimetype: "",
    fileName: "",
    fileType: "",
    filesize: "",
    filePath: "",
    targetFile: "",
    isCloudfiles:false
  });
  let chatwindowDetails: any = store.getState().chatWindowReducer?.chatWindowDetails;
  let { draftContact }: any = store.getState().recentchatReducer;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [videoduration, setVideoduration] = useState("00:00:00");
  const [currentduration, setCurrentduration] = useState("00:00");
  const [seektime, setseektime] = useState(0);
  const [filesIndex, setfileIndex] = useState(0);
  //const [isModalVisibleVideo, setIsModalVisibleVideo] = useState(false);
  const handleCancel = () => { setIsModalVisible(false); };
  //const handleCancelVideo = () => {setIsModalVisibleVideo(false);};
  const [isPlay, setPlay] = useState(false);
  //var vidDur:any = document.getElementById("videoPlayer");
  /**
   * @description Remove the file from list
   * @param file 
   */
  const removeOnclose = (fileIndex: number) => {
    filesAttach?.splice(fileIndex, 1);
    store.dispatch({
      type: actionTypes.FILE_ATTACHMENTS,
      payload: {
        filesAttach: filesAttach || []
      }
    });
    if(draftContact?.length > 0){
      DraftService.removeDraftMessage(chatwindowDetails, "");
    }
   
  };
  const openPreview = (file: filesArray,index:any) => {
  setfileIndex(index);
  store.dispatch({
    type: actionTypes.FILE_TEXT_MESSAGE,
    payload: {
      fileTextMessage:"",
      fileTexttype:index
    }
  });
 // console.log(newMessageList,"newMessageList")
    if (pptMimeFormats.indexOf(file.fileType) > -1 &&
      wordMimeFormats.indexOf(file?.fileType) > -1 &&
      excelMimeFormats.indexOf(file?.fileType) > -1) {
      setopenPreviewFile(file);
      setIsModalVisible(true);
    }
  };
  const [isModalVisible1, setIsModalVisible1] = useState(false);

  const handlePausePlay = () => {
    try {
      let video: any = document.getElementById("videoPlayer");
      if (isPlay) {
        video.pause();
        setPlay(false)
      }
      else {
        if (video) {
          video.addEventListener("timeupdate", seektimeupdate, false);

          /*    let seekslider:any = document.getElementById("seekslider");
             seekslider.addEventListener("change",vidSeek,false); */

          video.play();
          setPlay(true)
        }
      }
    }
    catch (e: any) {
      console.log("error is ", e)
    }

  }

  // const vidSeek = ()=>{
  //   let vid:any = document.getElementById("videoPlayer");
  //   let seekslider:any = document.getElementById("seekslider");
  //   var seekto = vid.duration * (seekslider.value / 100);
  //     vid.currentTime = seekto;
  // }
  const duration = (time: any) => {
    let timeDuration: any;
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    return timeDuration;
  }

  const showModalVideo = (file: any) => {
    if(file?.isCloudfiles ) { return true; }
    setopenPreviewFile(file);
    setIsModalVisible1(true);
    initVideoPlayer(file)
  };


  const initVideoPlayer = (file: any) => {
    window.URL = window.URL || window.webkitURL;

    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(file.filePath);

      let dur = duration(video.duration)
      setVideoduration(dur);

    }


    video.src = URL.createObjectURL(file.targetFile);

    /* let vid:any = document.getElementById("videoPlayer");

    if(vid)
    vid.addEventListener("timeupdate",seektimeupdate,false);
    else initVideoPlayer(file)  */

    /*       var vid:any = document.getElementById("videoPlayer");
  vid.onloadstart = function() {
    alert("Starting to load video");
  }; */

  }

  const seektimeupdate = () => {
    //let seekslider:any = document.getElementById("seekslider");
    let vid: any = document.getElementById("videoPlayer");
    var nt = vid?.currentTime * (100 / vid?.duration);
    //seekslider.value = nt;

    setseektime(nt)
    var curmins: any = Math.floor(vid?.currentTime / 60);
    var cursecs: any = Math.floor(vid?.currentTime - curmins * 60);
    var durmins: any = Math.floor(vid?.duration / 60);
    var dursecs: any = Math.floor(vid?.duration - durmins * 60);
    if (cursecs < 10) { cursecs = "0" + cursecs; }
    if (dursecs < 10) { dursecs = "0" + dursecs; }
    if (curmins < 10) { curmins = "0" + curmins; }
    if (durmins < 10) { durmins = "0" + durmins; }

    let currDuration = curmins + ":" + cursecs


    setCurrentduration(currDuration)
    if (currDuration === videoduration) {
      setPlay(false);
      setCurrentduration('00:00')
      setseektime(0);
    }
  }
  const handleCancel1 = () => { setIsModalVisible1(false); }

  return (
    <>
      {/* <FilePreview/> */}
      <div className={styles.fileAttachmentarea}>
        {filesAttach && filesAttach?.map((file: filesArray, index: any) =>
          <>
            {file?.fileType && file?.fileType.includes("image") &&  !file?.isCloudfiles && <div className={`${filesIndex ===index? styles.attachmentSelected:""} ${styles.imageAttachList}`}
              onClick={() => openPreview(file,index)}>
              <div className={styles.filesImage} >
                <img src={file.filePath} alt="fileName" />
                </div>
              <div className={styles.hoverClick}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={'Remove File'}>
                  <span className="icon_close"></span>
                </Tooltip>
              </div>
              <div className={styles.hoverClick}>
                <Tooltip placement="top" title={'Remove File'}>
                  <span className="icon_close" onClick={() => removeOnclose(index)}></span>
                </Tooltip>
              </div>
            </div>}
            {file?.fileType && (file?.fileType.includes("application") || file?.fileType.includes("text")) &&
              <div className={styles.fileAttachList} onClick={() => openPreview(file,index)}>
                <div className={styles.filesImage} >
                  <img src={wordMimeFormats.indexOf(file?.fileType) > -1
                    ? iconword :
                    pptFormats.indexOf(file.fileType) > -1
                      ? iconppt : file?.fileType === "application/pdf" ?
                        iconpdf : excelMimeFormats.indexOf(file.fileType) > -1
                          ? iconxls : zipMimeFormats.indexOf(file.fileType) > -1 ? iconzip : iconotherformat
                  } alt="fileName" /></div>
                <div className={styles.filesDetails}>
                  <Tooltip placement="top" title={file?.fileName} overlayClassName="tooltipCenter">
                    <span className={styles.fileName}>{file?.fileName?.substring(0, 10) + "..."}</span>
                  </Tooltip>
                  <span className={styles.fileDt}>{getFileSize(file?.filesize)}</span>
                  {file.isCloudfiles && <span className={styles.fileDt}>{file.filePath.includes('https://app.box.com') ? ' Box' : ' Drive'}</span>}
                </div>
                <div className={styles.hoverClick}>
                  <Tooltip placement="top" title={'Remove File'} overlayClassName="tooltipCenter">
                    <span className="icon_close" onClick={() => removeOnclose(index)}></span>
                  </Tooltip>
                </div>
                
              </div>
            }
            {file?.fileType && file?.fileType.includes("image") && file.isCloudfiles &&
              <div className={styles.fileAttachList} onClick={() => openPreview(file,index)}>
                <div className={styles.filesImage} >
                  <img src={iconNotSupported} alt="fileName" /></div>
                <div className={styles.filesDetails}>
                  <Tooltip placement="top" title={file?.fileName} overlayClassName="tooltipCenter">
                    <span className={styles.fileName}>{file?.fileName?.substring(0, 10) + "..."}</span>
                  </Tooltip>
                  <span className={styles.fileDt}>{getFileSize(file?.filesize)}</span>
                  <span className={styles.fileDt}>{file.filePath.includes('https://app.box.com') ? ' Box' : ' Drive'}</span>
                </div>
                <div className={styles.hoverClick}>
                  <Tooltip placement="top" title={'Remove File'} overlayClassName="tooltipCenter">
                    <span className="icon_close" onClick={() => removeOnclose(index)}></span>
                  </Tooltip>
                </div>
              </div>
            }
            {file?.fileType && file?.fileType.includes("video") &&
              <div className={styles.videoAttachList} >
                <div className={styles.videoFiles} onClick={() => showModalVideo(file)}>
                  {/* <video className="videoFluid" controls={true} preload="metadata">
                    <source src={file?.filePath} type="video/mp4" />
                  </video> */}
                  <video className="videoFluid" controls preload="metadata"
                  src={file?.filePath} id=""></video>
                  <div className={styles.videoPlay}></div>
                </div>
                <div className={styles.hoverClick}>
                  <Tooltip placement="top" title={'Remove File'}>
                    <span className="icon_close" onClick={() => removeOnclose(index)}></span>
                  </Tooltip>
                </div>
              </div>
            }
            {file?.fileType && file?.fileType.includes("audio") &&
              <div className={styles.audioAttachList}>
                <div className="audioNew audioAttachment">
                  {/* <div className={`lefts colorBG${2}`}>
                    {loginDetails?.userdetails?.profile_url ?
                      <img src={loginDetails?.userdetails?.profile_url} alt=""></img> :
                      <span>{loginDetails?.userdetails?.caller_id?.charAt(0).toUpperCase()}</span>}
                  </div> */}
                  <div className="rightsec">

                    <AudioPlayer
                      src={file?.filePath}
                      autoPlay={false}
                      autoPlayAfterSrcChange={false}
                      customIcons={{
                        play: <span className="icon_play"></span>,
                        pause: <span className="icon_pausebar"></span>
                      }}
                      customProgressBarSection={
                        [
                          RHAP_UI.MAIN_CONTROLS,
                          RHAP_UI.PROGRESS_BAR,
                          RHAP_UI.DURATION

                        ]
                      }
                      customControlsSection={
                        []
                      }
                    />
                  </div>

                </div>
                <div className={styles.hoverClick}>
                  <Tooltip placement="top" title={'Remove File'}>
                    <span className="icon_close" onClick={() => removeOnclose(index)}></span>
                  </Tooltip>
                </div>
              </div>
            }
          </>
        )}
      </div>
      <Modal title={openPreviewFile && openPreviewFile.fileName}
        centered
        visible={isModalVisible}
        onCancel={handleCancel}
        className="DocumentcustomPopup">
        <div className="chatNoteImgContent">
          <iframe title="File"
            src={openPreviewFile &&
              openPreviewFile.filePath}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
          ></iframe>

        </div>

      </Modal>
      <Modal
        centered
        visible={isModalVisible1}
        onCancel={handleCancel1} className="imageVideowmodal">
        <div className="modalheaders">
          <h2>{openPreviewFile?.fileName}</h2>
          <ul>
            <li><Tooltip placement="top" title={'Close'}>
              <span className="icon_close" onClick={handleCancel1}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatPlayerAudioConsec">
          <video className="videoFluid" controls preload="metadata"
          src={openPreviewFile.filePath} id="videoPlayer"></video>

          {/* <video  className="videoFluid" controls preload="metadata" id="videoPlayer">
                    <source src={openPreviewFile &&
            openPreviewFile.filePath} type="video/mp4" />
                  </video> */}
        </div>
        <div className={styles.playerContainer}>
          <div className={styles.controlSmall}>
            <Tooltip placement="top" title={isPlay ? "Pause" : "Play"}><div className={isPlay ? styles.pauseIcon : styles.playIcon} onClick={handlePausePlay}></div></Tooltip>
          </div>

          {/*   <input id="seekslider" type="range" min="0" max="100" value={seektime} step="1" ></input>  */}


          <Slider defaultValue={0} value={seektime} tooltipVisible={false} className="videoSliderColor" />
          {/*             <div className={styles.videoProgress}>
              <div className={styles.progressIndicator}>
              
              </div>
              <div className={styles.videoProgressFilled}></div>
              
            </div> */}
        </div>
        {<div className={styles.duration}>{currentduration} / {videoduration}</div>}
      </Modal>

    </>
  );
};
